import { render, staticRenderFns } from "./search-results-list.vue?vue&type=template&id=5702b458"
import script from "./search-results-list.vue?vue&type=script&lang=js"
export * from "./search-results-list.vue?vue&type=script&lang=js"
import style0 from "./search-results-list.vue?vue&type=style&index=0&id=5702b458&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports